import { useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { IClientTicketFull } from '@bustickus/models-client';
import { Flex } from 'components';
import { SpoilerCard } from 'shared/components';
import { DataRow } from '..';
import { CityData, TicketStatus } from './components';

interface IProps {
  ticket: IClientTicketFull;
}

function TicketCard(props: IProps) {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <SpoilerCard
      title='Данные билета'
      open={open}
      onOpenClick={() => setOpen(!open)}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <TicketStatus status={props.ticket.status} />
        <Flex
          direction='column'
          gap={5}
        >
          <DataRow
            icon={<bi.Ticket />}
            title='Номер билета:'
            value={props.ticket.number}
          />
          {props.ticket.trip?.number != null && (
            <DataRow
              icon={<bi.BusFront />}
              title='Номер рейса:'
              value={props.ticket.trip.number}
            />
          )}
        </Flex>

        <Flex
          direction='column'
          gap={5}
        >
          {props.ticket.departure != null && (
            <CityData
              type='departure'
              point={props.ticket.departure}
            />
          )}

          {props.ticket.arrival != null && (
            <CityData
              type='arrival'
              point={props.ticket.arrival}
            />
          )}
        </Flex>
      </Flex>
    </SpoilerCard>
  );
}

export default TicketCard;
